import { create } from 'zustand';

interface KeywordPerformanceFilterState {
  isOpen: boolean;
  usageBelow70: boolean;
  productivityBelow70: boolean;
  popularityBelow70: boolean;
  tempUsageBelow70: boolean;
  tempProductivityBelow70: boolean;
  tempPopularityBelow70: boolean;
  openModal: () => void;
  closeModal: () => void;
  setUsageBelow70: (value: boolean) => void;
  setProductivityBelow70: (value: boolean) => void;
  setPopularityBelow70: (value: boolean) => void;
  setTempUsageBelow70: (value: boolean) => void;
  setTempProductivityBelow70: (value: boolean) => void;
  setTempPopularityBelow70: (value: boolean) => void;
  resetFilters: () => void;
  applyFilters: () => void;
  getActiveFilter: () => string[];
}

const FilterNames = {
  usageBelow70: 'usage',
  productivityBelow70: 'productivity',
  popularityBelow70: 'popularity'
};

export const useKeywordPerformanceFilterStore = create<KeywordPerformanceFilterState>((set, get) => ({
  isOpen: false,
  usageBelow70: false,
  productivityBelow70: false,
  popularityBelow70: false,
  tempUsageBelow70: false,
  tempProductivityBelow70: false,
  tempPopularityBelow70: false,

  openModal: () => set((state) => ({
    isOpen: true,
    tempUsageBelow70: state.usageBelow70,
    tempProductivityBelow70: state.productivityBelow70,
    tempPopularityBelow70: state.popularityBelow70
  })),
  closeModal: () => set({ isOpen: false }),
  setUsageBelow70: (value: boolean) => set({ tempUsageBelow70: value, usageBelow70: value }),
  setProductivityBelow70: (value: boolean) => set({ tempProductivityBelow70: value, productivityBelow70: value }),
  setPopularityBelow70: (value: boolean) => set({ tempPopularityBelow70: value, popularityBelow70: value }),
  setTempUsageBelow70: (value: boolean) => set({ tempUsageBelow70: value }),
  setTempProductivityBelow70: (value: boolean) => set({ tempProductivityBelow70: value }),
  setTempPopularityBelow70: (value: boolean) => set({ tempPopularityBelow70: value }),

  resetFilters: () => set({
    usageBelow70: false,
    productivityBelow70: false,
    popularityBelow70: false,
    tempUsageBelow70: false,
    tempProductivityBelow70: false,
    tempPopularityBelow70: false
  }),

  applyFilters: () => set((state) => ({
    usageBelow70: state.tempUsageBelow70,
    productivityBelow70: state.tempProductivityBelow70,
    popularityBelow70: state.tempPopularityBelow70,
    isOpen: false
  })),

  getActiveFilter: () => {
    const filters: string[] = [];
    if (get().usageBelow70) filters.push(FilterNames.usageBelow70);
    if (get().productivityBelow70) filters.push(FilterNames.productivityBelow70);
    if (get().popularityBelow70) filters.push(FilterNames.popularityBelow70);
    return filters;
  }
}));
